import * as React from "react";
import type { SVGProps } from "react";
const SvgInvoiceNotFound = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={86}
    height={75}
    fill="none"
    viewBox="0 0 86 75" {...props}
  >
    <path
      fill="url(#invoice-not-found_svg__a)"
      d="M83.605 54.823h-4.91c-.859 0-1.664.456-2.12 1.208l-1.449 2.388c-.563.912-1.556 1.476-2.603 1.476h-4.105c-.751 0-1.449.348-1.878.965l-2.04 2.818a2.38 2.38 0 0 1-2.065.939l-4.508-.403a2.63 2.63 0 0 0-2.335 1.02l-2.2 2.898a3.66 3.66 0 0 1-2.898 1.449H45.45c-.751 0-1.45.456-1.771 1.127l-1.61 3.569a10.6 10.6 0 0 1-4.213-1.664 87 87 0 0 1-6.68-5.179c-4.106-3.541-8.882-8.344-13.578-14.596C9.307 41.702 3.404 30.62.452 24.61c-1.18-2.415.054-5.312 2.603-6.144l11.78-3.81 15.347-4.991L37.67 7.25a5.32 5.32 0 0 1 6.09 2.12c2.71 4.078 7.89 11.537 15.429 20.956.322.402.644.831.993 1.234.027.053.08.107.107.134 7.996 9.874 16.958 17.548 22.27 21.707.51.403.86.886 1.047 1.422"
      opacity={0.6}
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeMiterlimit={10}
      strokeWidth={0.698}
      d="M85 48.839h-4.91c-.86 0-1.664.456-2.12 1.207l-1.45 2.388c-.563.913-1.556 1.476-2.602 1.476h-4.105c-.752 0-1.45.349-1.879.966l-2.039 2.817a2.38 2.38 0 0 1-2.066.94l-4.508-.403a2.63 2.63 0 0 0-2.334 1.02l-2.2 2.898a3.66 3.66 0 0 1-2.898 1.448h-5.045c-.75 0-1.449.457-1.77 1.127l-1.61 3.57a10.6 10.6 0 0 1-4.213-1.665 87 87 0 0 1-6.681-5.178c-4.106-3.542-8.882-8.345-13.577-14.597C10.675 35.718 4.798 24.636 1.847 18.626c-1.18-2.415.054-5.313 2.603-6.145l11.779-3.81 15.348-4.99 7.486-2.415a5.32 5.32 0 0 1 6.091 2.12c2.71 4.078 7.889 11.537 15.428 20.955.322.403.644.832.993 1.234.027.054.08.108.107.135 7.996 9.874 16.958 17.548 22.271 21.707.51.402.859.885 1.047 1.422Z"
    />
    <path
      fill="url(#invoice-not-found_svg__b)"
      d="m21.434 36.79 2.468 2.63 25.33-10.411-2.496-2.415z"
    />
    <path
      fill="url(#invoice-not-found_svg__c)"
      d="M54.229 25.79c.031-1.008-1-1.857-2.303-1.898-1.304-.041-2.386.742-2.418 1.75-.031 1.006 1 1.856 2.303 1.897 1.304.041 2.386-.742 2.418-1.75"
    />
    <path
      fill="url(#invoice-not-found_svg__d)"
      d="m25.889 42.16 2.468 2.63 25.33-10.41-2.496-2.443z"
    />
    <path
      fill="url(#invoice-not-found_svg__e)"
      d="M58.688 31.141c.031-1.007-1-1.857-2.303-1.898-1.304-.04-2.386.742-2.417 1.75-.032 1.007.999 1.857 2.302 1.898 1.304.04 2.386-.743 2.418-1.75"
    />
    <path
      fill="url(#invoice-not-found_svg__f)"
      d="m30.746 47.122 2.469 2.63 25.33-10.385-2.496-2.441z"
    />
    <path
      fill="url(#invoice-not-found_svg__g)"
      d="M63.533 36.102c.032-1.007-.999-1.857-2.303-1.898s-2.385.742-2.417 1.75c-.032 1.007 1 1.856 2.303 1.898 1.303.04 2.386-.743 2.417-1.75"
    />
    <path
      fill="#00217B"
      d="M30.183 13.852c-.456-.51-1.047-.805-1.798-.913s-1.556.027-2.361.403-.993.537-1.315.885c-.322.35-.51.698-.564 1.074-.053.375.054.724.296 1.073.241.349.348.402.59.537.241.134.51.214.832.268.295.054.644.054.992.027.35 0 .752-.08 1.154-.134l1.45-.269c.509-.08.965-.16 1.421-.188.456-.026.886 0 1.288.054.403.054.752.161 1.074.349.322.16.59.402.831.724.322.456.456.94.403 1.422-.054.51-.295.966-.698 1.423-.43.456-1.02.858-1.798 1.207a6.6 6.6 0 0 1-2.12.564c-.67.053-1.287 0-1.85-.215a3.1 3.1 0 0 1-1.37-.912l.725-.322q.443.523 1.127.724c.456.134.94.188 1.503.134.536-.053 1.1-.214 1.663-.456.564-.241 1.1-.59 1.45-.966.348-.375.563-.751.617-1.154.053-.402-.054-.778-.322-1.153-.269-.376-.51-.51-.832-.644-.35-.135-.752-.188-1.235-.188s-1.046.08-1.663.188l-1.556.295c-1.047.188-1.932.214-2.657.053-.724-.134-1.288-.483-1.663-1.02-.376-.536-.457-.912-.376-1.395.054-.482.295-.939.698-1.368s.939-.805 1.61-1.1a6.2 6.2 0 0 1 2.012-.51c.67-.027 1.261.054 1.825.268.563.215.992.537 1.341.94l-.698.295zm2.227 8.962-7.755-10.76.537-.242 7.754 10.76z"
    />
    <defs>
      <linearGradient
        id="invoice-not-found_svg__a"
        x1={-0.004}
        x2={83.605}
        y1={40.602}
        y2={40.602}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
      <linearGradient
        id="invoice-not-found_svg__b"
        x1={61.271}
        x2={3.979}
        y1={0.763}
        y2={71.794}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={0.2} stopColor="#98CBFF" stopOpacity={0.8} />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="invoice-not-found_svg__c"
        x1={67.762}
        x2={10.469}
        y1={6.027}
        y2={77.085}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="invoice-not-found_svg__d"
        x1={66.587}
        x2={9.294}
        y1={5.042}
        y2={76.1}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="invoice-not-found_svg__e"
        x1={73.06}
        x2={15.768}
        y1={10.304}
        y2={81.335}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="invoice-not-found_svg__f"
        x1={71.954}
        x2={14.662}
        y1={9.396}
        y2={80.427}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="invoice-not-found_svg__g"
        x1={78.408}
        x2={21.116}
        y1={14.664}
        y2={85.695}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgInvoiceNotFound;
